import React from "react";
import { Grid, Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const LoginLandingPage = ({ showLoginInitially = false }) => {
  const navigate = useNavigate();
  
  // Custom LandingPage with Get Started button handler
  const CustomLandingPage = () => {
    // Enhanced version of LandingPage that passes the click handler
    const handleGetStarted = () => {
      navigate("/login");
    };
    
    return (
      <Box sx={{ width: "100%" }}>
        <LandingPageWrapper onGetStartedClick={handleGetStarted} />
      </Box>
    );
  };
  
  // Wrapper component for LandingPage to inject the click handler
  const LandingPageWrapper = ({ onGetStartedClick }) => {
    // This is a modified version of the LandingPage that accepts a click handler
    const { default: OriginalLandingPage } = require("../LandingPage");
    
    // Clone the LandingPage element and add our custom handler
    return React.cloneElement(<OriginalLandingPage />, {
      onGetStartedClick: onGetStartedClick
    });
  };

  return (
    <Container maxWidth="xl" disableGutters>
      {/* LandingPage content (always full width) */}
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <CustomLandingPage />
        </Grid>
      </Grid>
    </Container>
  );
};

export default LoginLandingPage;